
import './styles.css';
import moment from "moment"
import { FormikProps } from "formik"
import DefaultTextBold from "../../../../../components/Accessibility/DefaultTextBold"
import { AgendarAtendimentoFormik } from "../../../../../interfaces/entities/SaudeBemEstar/PrimeiroAgendamento/AgendarAtendimentoFormik"
import DefaultTable from "../../../../../components/Accessibility/DefaultTable"
import TableBold from "../../../../../components/Accessibility/DefaultTable/TableBold"
import TableRegular from "../../../../../components/Accessibility/DefaultTable/TableRegular"
import { getDayNameExtenso } from "../../../../../utils/DateFormat"
import { getBenef } from '../../../../../Store/storages/BeneficiarioStorage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import { useEffect, useState } from 'react';
import { ContatoModal } from './ContatoModal/ContatoModal';
import ButtonAccessibility from '../../../../../components/Accessibility/ButtonAccessibility';

export interface UserData {
    cel: string;
    tel: string;
    email: string;
}

interface ConfirmarDadosProps {
    formik: FormikProps<AgendarAtendimentoFormik>
}

export const ConfirmarDados: React.FC<ConfirmarDadosProps> = ({ formik }: ConfirmarDadosProps) => {
    const { contrastStyle, textStyleAccessibility } = useAccessibility();
    const [showContatoModal, setShowContatoModal] = useState<boolean>(false);
    const [userData, setUserData] = useState<UserData | null>(null)

    const dataAgendamento = [
        [<TableBold text="Profissional" />, <TableRegular text={formik.values?.selectedHour?.nomePrestador || ''} />],
        [<TableBold text="Especialidade" />, <TableRegular text={formik.values?.selectedHour?.especialidade || ''} />],
        [<TableBold text="Horário" />, <TableRegular text={`${formik.values?.selectedHour?.data} - ${getDayNameExtenso(moment(formik.values?.selectedHour?.data, 'DD/MM/YYYY').day())} às ${formik.values?.selectedHour?.hora}`} />]
    ]

    const dataContato = [
        [<TableBold text="Telefone" />, <TableRegular text={userData?.tel || '-'} />],
        [<TableBold text="Celular" />, <TableRegular text={userData?.cel || '-'} />],
        [<TableBold text="Email" />, <TableRegular text={userData?.email || '-'} />]
    ]

    const onSaveModal = (data: UserData) => {
        setUserData(data)
        formik.setFieldValue('userData', data)
    }

    useEffect(() => {
        setUserData(getBenef())
        formik.setFieldValue('userData', getBenef())
    }, []);

    return (
        <div className="confirmar-dados-container">
            <DefaultTextBold component="h2" text="Confirmação da reserva do agendamento" />
            <div className="confirmar-dados-table">
                <DefaultTable
                    data={dataAgendamento}
                    columnWidths={['25%', '75%']}
                />
            </div>
            <DefaultTextBold component="h2" text="Confirme seus dados de contato" />
            <div className="confirmar-dados-table">
                <DefaultTable
                    data={dataContato}
                    headers={["Dados de contato"]}
                    columnWidths={['25%', '75%']}
                />
            </div>
            <div className="flex-row">
                <FontAwesomeIcon icon={faEdit} color="#00995D" style={contrastStyle} />
                <button
                    className="editar-contato-button"
                    onClick={() => setShowContatoModal(true)}
                    style={textStyleAccessibility}
                >
                    Alterar dados de contato
                </button>
            </div>
            <div className="page-container-button">
                <ButtonAccessibility
                    variant="contained"
                    fullWidth
                    onClick={formik.submitForm}
                >
                    CONFIRMAR
                </ButtonAccessibility>
            </div>
            <ContatoModal
                open={showContatoModal}
                onClose={() => setShowContatoModal(false)}
                onSave={onSaveModal}
                userData={userData || { cel: '', tel: '', email: '' }}
            />
        </div>
    )

}